/* eslint-disable react/no-unknown-property */
import Image from 'next/image'
import React from 'react'

export default function Sec3() {
  return (
    <div>
      <section>
        <div className="grid md:col-span-12 relative">
          <div className="">
            <div className="pb-6 mb-20 md:mb-4 lg:max-w-[650px] tracking-[-1.21px]">
              <h2 className="sectionTitle !text-left">
                Design the form to <br /> match your brand style
              </h2>
            </div>

            <Image
              alt="Image"
              src="/ai/paper-stack.png"
              width={189}
              height={176}
              className="z-1000000 absolute right-[3%] bottom-1"
            />
          </div>
        </div>
        <div className="border bg-gray-100 rounded-md mt-[-7px] lg:width-full">
          <div className="flex flex-col top-[24px] lg:px-8 lg:py-6 px-6 py-2">
            <div className="border-transparent">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                width="1em"
                className="w-[21px] h-[20px]"
                style={{
                  fill: '#9d34da',
                  color: '#9d34da'
                }}
              >
                <defs fill="currentColor"></defs>
                <path
                  d="m17,51.5c0,2.49-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5,2.01-4.5,4.5-4.5,4.5,2.01,4.5,4.5Zm41-15.5c0,7.73-6.27,14-14,14-1,0-1.97-.11-2.91-.31-2.55,2.65-6.12,4.31-10.09,4.31-6.35,0-11.7-4.23-13.42-10.02-6.43-.22-11.58-5.49-11.58-11.98,0-4.86,2.89-9.03,7.05-10.92.48-8.41,7.43-15.08,15.95-15.08,4.43,0,8.43,1.8,11.33,4.7,1.14-.45,2.37-.7,3.67-.7,5.52,0,10,4.48,10,10,0,1.83-.5,3.53-1.35,5,3.25,2.56,5.35,6.53,5.35,11Zm-34-6c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4Zm12,0c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4Zm12,0c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="postTitle">Easy customization at your fingertips</p>
            <span className="text-slate-700 text-lg lg:max-w-[463px]">
              Your brand is unique, and your forms should be too. AI helps you
              choose colors, fonts, and layouts that match your unique style.
            </span>
          </div>
          <div className="px-8">
            <video
              src="/ai/Summarize.mp4"
              autoPlay
              loop
              muted
              className="border rounded-xl w-full h-auto object-cover"
            ></video>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-9 md:gap-3 gap-3 my-8 w-[full] h-auto">
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <div className="px-8 py-8">
              <Image width={19} height={19} alt="" src="/ai/Security.png" />
              <h2 className="font-bold py-2 text-[18px]">
                Questions about your Notion docs & tasks
              </h2>
              <p className="text-[16px]">
                Get the answers you need without interrupting a colleague.
              </p>
              <Image
                width={245}
                height={159}
                alt=""
                className="mt-7"
                src="/ai/SSO.webp"
              />
            </div>
          </div>
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <div className="px-8 pt-8">
              <Image width={26} height={26} alt="" src="/ai/Hello.png" />
              <h2 className="font-bold py-2 text-[18px]">
                Questions about the world
              </h2>
              <p className="text-[16px]">
                Chat about any topic. Brainstorm new ideas and perspectives.
              </p>
              <Image
                width={245}
                height={159}
                alt=""
                className="mt-7"
                src="/ai/translate.webp"
              />
            </div>
          </div>
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <div className="px-8 py-8">
              <Image width={26} height={26} alt="" src="/ai/Shield.png" />
              <h2 className="font-bold py-2 text-[18px]">
                Questions about Slack & Google Docs
              </h2>
              <p className="text-[16px]">
                Soon, Notion AI will be able to search even more tools.
              </p>
              <Image
                width={245}
                height={159}
                alt=""
                className="mt-7"
                src="/ai/voice-tone.webp"
              />
            </div>
          </div>
        </div>
        <div className="mt-12">
          <p className="mx-auto flex items-center justify-center text-2xl max-w-xl text-center font-medium">
            {`"Previously, we had to guess which platform held the information we needed. Now, people can simply ask Notion AI."`}
          </p>
          <div className="flex items-center justify-center gap-3">
            <Image
              src="/ai/hex.png"
              alt="hex-logo"
              width={50}
              height={20}
              className="rounded-md"
            />
            <div className="my-5 flex flex-col justify-start items-start">
              <p>Ganesh Ramanarayanan</p>
              <p className="font-semibold">Head of Engineering, Hex</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
